import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { workApi } from 'features/work/query';
import { WorkState } from 'features/work/types';

const initialState: WorkState = {
  workDetail: null,
  workComments: null,
};

const workSlice = createSlice({
  name: 'work',
  initialState,
  reducers: {
    setWorkDetail: (state, action: PayloadAction<any>) => {
      state.workDetail = action.payload;
    },
  },
  extraReducers: builder => {
    const { GetWorkDetail, GetWorkComments } = workApi.endpoints;

    builder
      .addMatcher(
        isAnyOf(GetWorkDetail.matchRejected, GetWorkDetail.matchPending),
        state => {
          state.workDetail = null;
        }
      )
      .addMatcher(GetWorkDetail.matchFulfilled, (state, { payload }) => {
        state.workDetail = payload;
      })

      .addMatcher(
        isAnyOf(GetWorkComments.matchPending, GetWorkComments.matchRejected),
        state => {
          state.workComments = null;
        }
      )
      .addMatcher(GetWorkComments.matchFulfilled, (state, { payload }) => {
        state.workComments = payload;
      });
  },
});

export const { setWorkDetail } = workSlice.actions;
export default workSlice.reducer;
